import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Join from "@/pages/Join";
import SignIn from "@/pages/SignIn";
import Welcome from "@/pages/Welcome";
import Vault from "@/pages/Vault";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import BuildYourSet from "@/pages/BuildYourSet";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { Pricing, Contact, Account } from "@/pages/Static";
import AboutLab from "@/pages/AboutLab";
import CardServices from "@/pages/CardServices";
import ComicServices from "@/pages/ComicServices";
import HowItWorks from "@/pages/HowItWorks";
import OurProcess from "@/pages/OurProcess";
import ShippingInsurance from "@/pages/ShippingInsurance";
import Confidentiality from "@/pages/Confidentiality";
import Results from "@/pages/Results";
import FAQ from "@/pages/FAQ";
import SubmitCollectible from "@/pages/SubmitCollectible";
import TrustCenter from "@/pages/TrustCenter";
import Admin from "@/pages/Admin";
import AfterHours from "@/pages/AfterHours";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ServiceLanding from "@/pages/ServiceLanding";
import Library from "@/pages/Library";
import LibraryArticle from "@/pages/LibraryArticle";
import BeforeAfter from "@/pages/BeforeAfter";
import ServicesHub from "@/pages/ServicesHub";
import ServiceDetail from "@/pages/ServiceDetail";
import CardCareLab from "@/pages/CardCareLab";
import { SEO_PAGE_SLUGS } from "@/data/seoPages";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/join" element={<Join />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/welcome" element={<ProtectedRoute><Welcome /></ProtectedRoute>} />
            <Route path="/vault" element={<ProtectedRoute><Vault /></ProtectedRoute>} />
            <Route path="/shop" element={<ProtectedRoute><Shop /></ProtectedRoute>} />
            <Route path="/shop/:category" element={<ProtectedRoute><Shop /></ProtectedRoute>} />
            <Route path="/product/:slug" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
            <Route path="/build-your-set" element={<ProtectedRoute><BuildYourSet /></ProtectedRoute>} />
            <Route path="/submit" element={<ProtectedRoute><SubmitCollectible /></ProtectedRoute>} />
            <Route path="/card-lab" element={<Navigate to="/submit" replace />} />
            <Route path="/submit-cards" element={<Navigate to="/submit" replace />} />
            <Route path="/card-cleaning" element={<Navigate to="/card-services" replace />} />
            <Route path="/grading-prep" element={<Navigate to="/card-services" replace />} />
            <Route path="/card-services" element={<ProtectedRoute><CardServices /></ProtectedRoute>} />
            <Route path="/comic-services" element={<ProtectedRoute><ComicServices /></ProtectedRoute>} />
            {SEO_PAGE_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<ProtectedRoute><ServiceLanding slug={slug} /></ProtectedRoute>} />
            ))}
            <Route path="/before-after" element={<ProtectedRoute><BeforeAfter /></ProtectedRoute>} />
            <Route path="/services" element={<ProtectedRoute><ServicesHub /></ProtectedRoute>} />
            <Route path="/services/:slug" element={<ProtectedRoute><ServiceDetail /></ProtectedRoute>} />
            <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
            <Route path="/library/:slug" element={<ProtectedRoute><LibraryArticle /></ProtectedRoute>} />
            <Route path="/card-care-lab" element={<ProtectedRoute><CardCareLab /></ProtectedRoute>} />
            <Route path="/how-it-works" element={<ProtectedRoute><HowItWorks /></ProtectedRoute>} />
            <Route path="/our-process" element={<ProtectedRoute><OurProcess /></ProtectedRoute>} />
            <Route path="/trust-center" element={<ProtectedRoute><TrustCenter /></ProtectedRoute>} />
            <Route path="/trust" element={<Navigate to="/trust-center" replace />} />
            <Route path="/after-hours" element={<ProtectedRoute><AfterHours /></ProtectedRoute>} />
            <Route path="/shipping-insurance" element={<ProtectedRoute><ShippingInsurance /></ProtectedRoute>} />
            <Route path="/confidentiality" element={<ProtectedRoute><Confidentiality /></ProtectedRoute>} />
            <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
            <Route path="/faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/sports-cards" element={<Navigate to="/shop/sports-cards" replace />} />
            <Route path="/pokemon-cards" element={<Navigate to="/shop/pokemon" replace />} />
            <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/about" element={<ProtectedRoute><AboutLab /></ProtectedRoute>} />
            <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
            <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141519",
              border: "1px solid #2a2c33",
              color: "#fff",
            },
          }}
        />
      </BrowserRouter>
    </CartProvider>
    </AuthProvider>
  );
}

export default App;
